export default "/_next/static/chunks/fonts/Montserrat-SemiBoldItalic-latin-82b50a402bfe2fd05852a53006424e72.woff2";